<template>
  <div class="app">
    <CbTopBar :on-back="handleBack" :share-params="shareParams" />
    <audio class="global-audio-control" ref="audio" autoplay="autoplay" controls>
      <source :src="musicSrc" type="audio/mpeg" />
      Your browser does not support this audio format.
    </audio>
    <router-view />
  </div>
</template>
<script>
import { trackPv, bridge, get } from "@changba/funny";
import { mapState } from "vuex";

export default {
  name: "App",
  computed: {
    ...mapState({
      shareImg: (state) => state.shareImg,
      musicSrc: (state) => state.musicSrc,
    }),
    shareParams() {
      return {
        title: "《我想和你唱》第五季招募进行中",
        content: "加入明星合唱赢同台录制机会",
        imageurl: this.shareImg,
        targeturl: window.location.origin + window.location.pathname,
      };
    },
    routeName() {
      return this.$route.name;
    },
  },
  watch: {
    musicSrc(val) {
      const audio = this.$refs.audio;
      if (val) {
        audio.load();
        audio.play();
      } else {
        audio.pause();
      }
    },
  },
  mounted() {
    trackPv();
    this.findTrackIssue();
  },
  methods: {
    handleBack() {
      if (this.$route.name !== "Home") {
        this.$router.go(-1);
      } else {
        bridge.closePage();
      }
    },
    findTrackIssue() {
      setTimeout(() => {
        // 是否是新容器
        const hasBridge = window.WebViewJavascriptBridge;
        const version = hasBridge ? "V2" : "V1";
        // 是否已经插入成功
        const hasInsertSuccess = window.cbStats && window.sensorsDataAnalytic201505;
        const insertState = hasInsertSuccess ? "Success" : "Error";
        const url = `/api/activity/singWithYou/collect${insertState}${version}`;
        get({
          url,
          showLoading: false,
        });
      }, 1000);
    },
  },
};
</script>

<style lang="scss">
html,
body {
  background-color: #2c1372;
}

.cb-top-bar__back,
.cb-top-bar__share {
  transform: scale(1.1);
  background-color: rgba(#e5e5e5, 0.4);
}

.global-audio-control {
  display: none;
}
</style>
